import React from 'react'
import { MainContent, MainContentMobile } from '.'
import { useDispatch, useSelector } from 'react-redux'
import { fetchFeaturedPrograms, fetchPrograms } from '../../../features/programs/slice'
import { useViewport } from '../../../utils'
import { StatusHandler } from '../../../components'

const PageContent = () => {
  const { isDesktop } = useViewport()
  const dispatch = useDispatch()
  const programs = useSelector(state => state.programs)
  const { status, error, data, data_featured } = programs

  // request data to FEATURED programs API
  React.useEffect(() => {
    dispatch(fetchFeaturedPrograms())
    // eslint-disable-next-line
  }, [])

  return (
    <StatusHandler
      status={status}
      error={error}
      onRetry={() => dispatch(fetchPrograms())}
    >
      {isDesktop ? (
        <MainContent programs={data} defaultFeaturedItems={data_featured} />
      ) : (
        <MainContentMobile programs={data} />
      )}
    </StatusHandler>
  )
}

export { PageContent }
